/**
 * Register University Review Wizard Alpine Component
 */
import universityReviewWizard from './wizard.js';

document.addEventListener('livewire:init', () => {
    window.Alpine.data('universityReviewWizard', universityReviewWizard);
});



















